module.exports = __webpack_public_path__ + "static/media/ligne-dassistance.50c6ed4c.svg";